import { TBaseEntity } from "@/api/entities/entity";
import { valueOf } from "@/types/common";

// 級 is persisted as a numeric code; the Japanese text lives in the *_LABEL maps below.
export const EXAM_GRADE_1YEAR = {
  BASIC: 1,
  ELEMENTARY: 2,
} as const;

export const EXAM_GRADE_1YEAR_LABEL = {
  [EXAM_GRADE_1YEAR.BASIC]: "基礎級",
  [EXAM_GRADE_1YEAR.ELEMENTARY]: "初級",
} as const;

export const EXAM_GRADE_FINAL = {
  THIRD: 1,
  SPECIALIZED: 2,
} as const;

export const EXAM_GRADE_FINAL_LABEL = {
  [EXAM_GRADE_FINAL.THIRD]: "３級",
  [EXAM_GRADE_FINAL.SPECIALIZED]: "専門級",
} as const;

export const EMPLOYER_CHANGE_RESTRICTION_PERIOD = {
  ONE_YEAR: 1,
  TWO_YEARS: 2,
} as const;

export const EMPLOYER_CHANGE_RESTRICTION_PERIOD_LABEL = {
  [EMPLOYER_CHANGE_RESTRICTION_PERIOD.ONE_YEAR]: "1年",
  [EMPLOYER_CHANGE_RESTRICTION_PERIOD.TWO_YEARS]: "2年",
} as const;

export type TExamGrade1Year = valueOf<typeof EXAM_GRADE_1YEAR>;
export type TExamGradeFinal = valueOf<typeof EXAM_GRADE_FINAL>;
export type TEmployerChangeRestrictionPeriod = valueOf<typeof EMPLOYER_CHANGE_RESTRICTION_PERIOD>;

export type TMasterCompanyMainSkill = TBaseEntity & {
  companySpecificBusinessClassificationId: number;
  mainSkillName: string; //主たる技能
  examName1Year: string; //試験名（1年経過時まで）
  examGrade1Year: TExamGrade1Year | null; //級（1年経過時まで）
  examNameFinal: string; //試験名（育成就労終了まで）
  examGradeFinal: TExamGradeFinal | null; //級（育成就労終了まで）
  employerChangeRestrictionPeriod: TEmployerChangeRestrictionPeriod | null; //育成就労実施者の変更を制限する期間(分野単位)
  isEmploymentTraining: boolean; //育成就労
  isHidden: boolean;
  order: number;
};
